import { useEffect, useMemo, useState } from "react";
import { useAppSelector } from "../../../../redux/hooks";

import { UsersListInterface } from "../../../../redux/interfaces/admin.interface";

import moment from "moment";
import "moment/locale/ro";

import Dropdown, { DropdownValue } from "../../../../components/misc/Dropdown";
import {
  getCurrentYearOrMonth,
  getDaysInMonth,
} from "../../../../utils/dateAndTime";
import useTableCtx from "../../../../components/tables/tableContext/useTableCtx";

const lastThreeYears = [
  getCurrentYearOrMonth("year"),
  getCurrentYearOrMonth("year") - 1,
  getCurrentYearOrMonth("year") - 2,
];

const usersRole = [
  { id: "putAway", label: "Putaway" },
  { id: "rearanjare", label: "Rearanjare" },
  { id: "umplere", label: "Umplere" },
  { id: "comenziColectate", label: "Comenzi colectate" },
  { id: "comenziVerificate", label: "Comenzi verificate" },
  { id: "produseReceptionate", label: "Produse receptionate" },
  { id: "produseSolutionate", label: "Produse solutionate" },
  { id: "receptiiDeschise", label: "Receptii deschise" },
];

const monthsDataDropdownValue = moment
  .monthsShort()
  .map((month: string, index: number) => {
    return {
      id: index + 1,
      label: month,
    };
  });

const yearsDataDropdownValue = lastThreeYears.map((year: number) => {
  return {
    id: year,
    label: year,
  };
});
const previousMonth = moment().subtract(1, "month");

const usersRoleDropdownValue = usersRole.map((role) => {
  return {
    id: role.id,
    label: role.label,
  };
});

const allOption = {
  id: 0,
  label: "Toate",
};

function DropdownsPageHeader() {
  const { handleTableSearch } = useTableCtx() || {};

  const [selectedDay, setSelectedDay] = useState<DropdownValue>(allOption);
  const [selectedMonth, setSelectedMonth] = useState<DropdownValue>(
    monthsDataDropdownValue[previousMonth.month()],
  );
  const [selectedYear, setSelectedYear] = useState<DropdownValue>(
    yearsDataDropdownValue.find((year) => year.id === previousMonth.year()) ??
      yearsDataDropdownValue[0],
  );
  const [selectedUsers, setSelectedUsers] = useState<DropdownValue[]>([]);
  const [selectedRoles, setselectedRoles] = useState<DropdownValue[]>([]);

  const daysDropdownValue = useMemo(
    () =>
      getDaysInMonth(selectedMonth.id, selectedYear.id).map((day) => ({
        id: parseInt(day),
        label: day,
      })),
    [selectedMonth.id, selectedYear.id],
  );

  const daysDropdownValueWithAll = [
    { id: 0, label: "Toate" },
    ...daysDropdownValue,
  ];

  useEffect(() => {
    if (
      Number(selectedDay.id) !== 0 &&
      !daysDropdownValue.some((day) => day.id === Number(selectedDay.id))
    ) {
      setSelectedDay(allOption);
    }
  }, [daysDropdownValue, selectedDay.id]);

  const {
    admin: {
      users: {
        data: { data: users },
      },
    },
  } = useAppSelector((state) => ({
    admin: state.admin,
  }));

  useEffect(() => {
    handleTableSearch && handleTableSearch("selectedDay", selectedDay?.id);
  }, [handleTableSearch, selectedDay]);

  useEffect(() => {
    handleTableSearch && handleTableSearch("selectedMonth", selectedMonth?.id);
  }, [handleTableSearch, selectedMonth]);

  useEffect(() => {
    handleTableSearch && handleTableSearch("selectedYear", selectedYear?.id);
  }, [handleTableSearch, selectedYear]);

  useEffect(() => {
    handleTableSearch &&
      handleTableSearch("selectedUsers", JSON.stringify(selectedUsers));
  }, [handleTableSearch, selectedUsers]);

  useEffect(() => {
    handleTableSearch &&
      handleTableSearch("selectedRoles", JSON.stringify(selectedRoles));
  }, [handleTableSearch, selectedRoles]);

  const usersDropdownValue = users.map((user: UsersListInterface) => {
    return {
      id: user.userId,
      label: user.userName,
    };
  });

  return (
    <div className="grid grid-cols-1 gap-4 pb-4 sm:grid-cols-2 xl:grid-cols-5">
      <Dropdown
        className="!mb-0 min-w-0"
        title="Selecteaza ziua"
        data={daysDropdownValueWithAll}
        singleValue={selectedDay}
        setSingleValue={(value) => value && setSelectedDay(value)}
      />

      <Dropdown
        className="!mb-0 min-w-0"
        title="Selecteaza luna"
        data={monthsDataDropdownValue}
        singleValue={selectedMonth}
        setSingleValue={(value) => value && setSelectedMonth(value)}
      />

      <Dropdown
        className="!mb-0 min-w-0"
        title="Selecteaza anul"
        data={yearsDataDropdownValue}
        singleValue={selectedYear ?? yearsDataDropdownValue[0]}
        setSingleValue={(value) => value && setSelectedYear(value)}
      />

      <Dropdown
        className="!mb-0 min-w-0"
        title="Utilizatori"
        data={usersDropdownValue}
        multipleValues={selectedUsers}
        setMultipleValues={setSelectedUsers}
      />

      <Dropdown
        className="!mb-0 min-w-0"
        title="Roluri"
        data={usersRoleDropdownValue}
        multipleValues={selectedRoles}
        setMultipleValues={setselectedRoles}
      />

      {/* <Dropdown
        className="!mb-0 min-w-0"
        title="Categorie utilizator"
        data={monthsDataDropdownValue}
        singleValue={selectedMonth}
        setSingleValue={setSelectedMonth}
      /> */}
    </div>
  );
}

export default DropdownsPageHeader;
